import React from 'react';
import { Typography, ProductCardsSection } from 'common/components';
import { createElementKey } from 'utils';
import {
  INTERIOR_DOORS_MODERN_MATERIAL_LIST,
  ModerMaterialsProductStructure,
} from './interior-doors-modern-materials-constants';
import {
  modernMaterialsName,
  modernMaterialsIconWrapper,
  modernMaterialsImage,
  modernMaterialsProduct,
  modernMaterialsProductProperty,
  modernMaterialsProductPropertyWrapper,
} from './interior-doors-modern-materials-styles';
import { INTERIOR_DOORS_ELEMENT_BLOCK } from '../../interior-doors-constants';

export const InteriorDoorsModernMaterials = () => (
  <ProductCardsSection
    elementBlock={INTERIOR_DOORS_ELEMENT_BLOCK}
    description="Наши двери выполнены из&nbsp;практичных материалов, которые долго будут радовать вас качеством и&nbsp;внешним видом."
    productList={INTERIOR_DOORS_MODERN_MATERIAL_LIST}
    renderProductCard={({ alt, imgSrc, name, properties, iconList }: ModerMaterialsProductStructure) => (
      <>
        <img alt={alt} className={modernMaterialsImage} src={imgSrc} title={name} />
        <Typography adaptive={false} className={modernMaterialsName} size="subtitle" variant="m">
          {name}
        </Typography>
        <div className={modernMaterialsProductPropertyWrapper}>
          {properties.map((property, index) => (
            <Typography
              className={modernMaterialsProductProperty}
              color="text-secondary"
              key={createElementKey('modern-material-property', index)}
              variant="s"
              size="body_long">
              {property.name}
              <Typography as="span" variant="s" size="body_long">
                {property.value}
              </Typography>
            </Typography>
          ))}
        </div>
        <div className={modernMaterialsIconWrapper}>
          {iconList.map(({ icon: ProductIcon, textColor }, index) => (
            <ProductIcon
              color={textColor}
              key={createElementKey('moderMaterialProductIcon', index)}
              size="l"
              type="outline"
            />
          ))}
        </div>
      </>
    )}
    swiperSlideClassName={modernMaterialsProduct}
    title="Современные материалы"
  />
);
